import { render, staticRenderFns } from "./GrmCloseBtn.vue?vue&type=template&id=bb4b7626&"
import script from "./GrmCloseBtn.vue?vue&type=script&lang=js&"
export * from "./GrmCloseBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb4b7626')) {
      api.createRecord('bb4b7626', component.options)
    } else {
      api.reload('bb4b7626', component.options)
    }
    module.hot.accept("./GrmCloseBtn.vue?vue&type=template&id=bb4b7626&", function () {
      api.rerender('bb4b7626', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/button/GrmCloseBtn.vue"
export default component.exports